import React, { useRef } from "react"
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import Downloadcon from "@mui/icons-material/Download"
import PrintIcon from "@mui/icons-material/Print"
import { QRCodeSVG } from "qrcode.react"

function ModalQRCode({ open, handleClose, url }) {
    const qrCodeRef = useRef()

    const downloadQRCode = () => {
        const svg = qrCodeRef.current
        if (!svg) {
            console.error("QR Code SVG não encontrado!")
            return
        }

        const serializer = new XMLSerializer()
        const svgString = serializer.serializeToString(svg)
        const svgBlob = new Blob([svgString], {
            type: "image/svg+xml;charset=utf-8",
        })
        const url = URL.createObjectURL(svgBlob)

        const image = new Image()
        image.onload = () => {
            const canvas = document.createElement("canvas")
            canvas.width = image.width
            canvas.height = image.height
            const ctx = canvas.getContext("2d")
            if (ctx) {
                ctx.drawImage(image, 0, 0)
                URL.revokeObjectURL(url)

                canvas.toBlob((blob) => {
                    if (blob) {
                        const link = document.createElement("a")
                        link.href = URL.createObjectURL(blob)
                        link.download = "qrcode.png"
                        link.click()
                    }
                }, "image/png")
            }
        }
        image.src = url
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            scroll="paper"
            fullWidth
        >
            <DialogTitle id="form-dialog-title">Baixar QR Code</DialogTitle>
            <Box
                sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <IconButton aria-label="close" onClick={downloadQRCode}>
                    <Downloadcon color="primary" />
                </IconButton>
                <IconButton aria-label="close" onClick={() => window.print()}>
                    <PrintIcon color="primary" />
                </IconButton>
                <IconButton aria-label="close" onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent>
                <Box display="flex" justifyContent="center">
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "10px",
                        }}
                    >
                        <QRCodeSVG ref={qrCodeRef} value={url} size={512} />
                    </div>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default ModalQRCode
